import "../styling/scss/App.scss";
import React, { useMemo, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";

import { SXDropdown, NGDropdownListItem } from "@common/components/ui-components/SXDropdown";
import { useAppSelector, useAppDispatch } from "../app/hooks";
// import http from "./common/NGhttp";
// import { IAppContext, StatesContext } from "../app/AppContext";
import { ng } from "@common/ngds";

// import { migrateGeneration } from "../app/funlib";
import { useTranslation } from "react-i18next";
import { addAlert } from "../features/ui/uiSlice";
import { t } from "i18next";
import { useProject } from "../features/projects/projectSlice";
import { report_exception } from "./ui-components/SXAlert/SXAlertMessage";
import { useDevConfig } from "../App";

// --- Constants ---

const EUROCODE_GENERATION = [
  { name: "eurocode_generation_1_.label", id: ng.eurocode.Generation.GENERATION_1, disabled: false },
  { name: "eurocode_generation_2_.label", id: ng.eurocode.Generation.GENERATION_2, disabled: true },
];

const NATIONAL_ANNEXES: Array<NGDropdownListItem<ng.eurocode.Annex>> = [
  //  { name: "country_belgium_", id: ng.eurocode.Annex.ANNEX_BELGIUM },
  { name: "country_common_.label", id: ng.eurocode.Annex.ANNEX_COMMON, flag: "fi fi-eu" },
  { name: "country_denmark_.label", id: ng.eurocode.Annex.ANNEX_DENMARK, flag: "fi fi-dk" },
  //  { name: "country.estonia", id: ng.eurocode.Annex.ANNEX_ESTONIA },
  { name: "country_finland_.label", id: ng.eurocode.Annex.ANNEX_FINLAND, flag: "fi fi-fi" },
  //  { name: "country.germany", id: ng.eurocode.Annex.ANNEX_GERMANY },
  { name: "country_great_britain_.label", id: ng.eurocode.Annex.ANNEX_GREAT_BRITAIN, flag: "fi fi-gb" },
  //  { name: "country.hungary", id: ng.eurocode.Annex.ANNEX_HUNGARY },
  //  { name: "country.latvia", id: ng.eurocode.Annex.ANNEX_LATVIA },
  //  { name: "country.netherlands", id: ng.eurocode.Annex.ANNEX_NETHERLANDS },
  { name: "country_norway_.label", id: ng.eurocode.Annex.ANNEX_NORWAY, flag: "fi fi-no" },
  //  { name: "country.poland", id: ng.eurocode.Annex.ANNEX_POLAND },
  //  { name: "country.romania", id: ng.eurocode.Annex.ANNEX_ROMANIA },
  //  { name: "country.spain", id: ng.eurocode.Annex.ANNEX_SPAIN },
  { name: "country_sweden_.label", id: ng.eurocode.Annex.ANNEX_SWEDEN, flag: "fi fi-se" },
  //  { name: "country.turkey", id: ng.eurocode.Annex.ANNEX_TURKEY },
];

const CONSEQUENCE_CLASS = [
  { name: "class_1_.label", id: ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_1 },
  { name: "class_2_.label", id: ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_2 },
  { name: "class_3_.label", id: ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_3 },
];

const RELIABILITY_CLASS = [
  { name: "reliability_class_1_.label", id: ng.structure.ReliabilityClass.RELIABILITY_CLASS_1 },
  { name: "reliability_class_2_.label", id: ng.structure.ReliabilityClass.RELIABILITY_CLASS_2 },
  { name: "reliability_class_3_.label", id: ng.structure.ReliabilityClass.RELIABILITY_CLASS_3 },
];

// --- Main component ---
interface ProjectCodeSettingsProps {
  factorUpdate?: boolean;
  project?: ng.project.Data;
  config?: any;
  user?: any;
}

export const SXCodeSettings = (props: ProjectCodeSettingsProps) => {
  // --- Dummy context and input.code for development/compilation ---
  // TODO: Replace these with real data sources when available

  const { project: selProject, setEc, setUpdateSettings } = useProject();
  const isDev = useDevConfig();

  const { annex, generation, cc, reliabilityClass } = useMemo(() => {
    if (selProject?.data?.data?.input) {
      const input = selProject.data.data.input;
      return {
        annex: ng.eurocode.Annex_FromObject(input.ec?.nationalAnnex) ?? ng.eurocode.Annex.ANNEX_UNSPECIFIED,
        generation:
          ng.eurocode.Generation_FromObject(input.ec?.generation) ?? ng.eurocode.Generation.GENERATION_UNSPECIFIED,
        cc:
          ng.structure.ConsequenceClass_FromObject(input.structures?.[0]?.cc) ??
          ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED,
        reliabilityClass:
          ng.structure.ReliabilityClass_FromObject(input.structures?.[0]?.reliabilityClass) ??
          ng.structure.ReliabilityClass.RELIABILITY_CLASS_UNSPECIFIED,
      };
    }
    return {
      annex: ng.eurocode.Annex.ANNEX_UNSPECIFIED,
      generation: ng.eurocode.Generation.GENERATION_UNSPECIFIED,
      cc: ng.structure.ConsequenceClass.CONSEQUENCE_CLASS_UNSPECIFIED,
      reliabilityClass: ng.structure.ReliabilityClass.RELIABILITY_CLASS_UNSPECIFIED,
    };
  }, [selProject]);

  const context: any = {
    user: {
      id: "dummy-user-id",
      settings: {
        defaultValues: {
          generation: undefined,
          nationalAnnex: undefined,
        },
      },
    },
  };

  // Dummy input.code for development/compilation
  const dummyInputCode = {
    type: "ec",
    ec: {
      nationalAnnex: undefined,
      generation: undefined,
    },
  };

  //NOTE! Only one material and one section for beam as for now

  // --- Contexts ---
  //const states = useContext(StatesContext);
  const dispatch = useAppDispatch();

  const { t, i18n } = useTranslation();

  // --- Local variables ---
  let input: any = props.project?.input || { code: dummyInputCode };
  let structure = new ng.structure.Data();
  let element = new ng.element.Data();

  if (input) {
    // Type narrowing for dummy or real input
    if (input.code && input.code.type === "ec") {
      // na = input.code.ec.nationalAnnex;
      //gen = input.code.ec.generation;
    }
    if (input.structures) {
      structure = input.structures[0] || {};

      if (structure.elements) {
        element = structure.elements[0] || {};
        // inspLvl = element.inspectionLevel || ng.element.InspectionLevel.INSPECTION_LEVEL_NORMAL;
      }
    }
  }

  const update_generation = async (val: { id: ng.eurocode.Generation }) => {
    if (input && input.code && input.code.type === "ec" && context.user?.settings) {
      let fromGen = input.code.ec.generation;
      let toGen = val.id;
      // If the generation is not changed, do nothing
      if (fromGen === toGen) {
        return;
      }

      // If the generation is changed, update the project
      input.code.ec.generation = val.id;
      // Migrate the project to the new generation
      //  input = migrateGeneration(input, fromGen, toGen);
      if (!input || !input.code || input.code.type !== "ec") {
        dispatch(
          addAlert({
            type: "error",
            text: t("MSG_migration_of_eurocode_generation_failed_.label"),
            id: "",
            status: "",
          }),
        );
        return;
      }
      await setUpdateSettings({ cc, generation: val.id, nationalAnnex: annex, reliability: reliabilityClass });
    }
  };

  const update_annex = async (val: { id: ng.eurocode.Annex }) => {
    await setUpdateSettings({ cc, generation: generation, nationalAnnex: val.id, reliability: reliabilityClass });
    // Save this latest choice for NA as a default value for this user
    // http.put("/users/", null, { ...context.user }, () => { });
  };

  const update_cc = async (val: { id: ng.structure.ConsequenceClass }) => {
    await setUpdateSettings({
      cc: val.id,
      generation: generation,
      nationalAnnex: annex,
      reliability: reliabilityClass,
    });
    //if (structure) {
    // structure.cc = val.id;
    // }
  };
  const update_reliabilityClass = async (val: { id: ng.structure.ReliabilityClass }) => {
    if (structure) {
      await setUpdateSettings({ cc: cc, generation: generation, nationalAnnex: annex, reliability: val.id });
      // props.pushChanges(context);
    }
  };

  const GetCountry = (na: ng.eurocode.Annex) => {
    return NATIONAL_ANNEXES.find((a) => a.id === na);
  };

  const GetGeneration = (gen: ng.eurocode.Generation) => {
    return EUROCODE_GENERATION.find((a) => a.id === gen);
  };

  //----------------------------------------------------
  return (
    <Container fluid id="sx-table-container" className="ps-0 px-0">
      <Row className="align-items-center">
        <Col>
          <Container style={{ fontSize: 12, color: "#696969" }}>
            {/* All code settings side by side, each with its label above the dropdown */}
            <Row className="container-row" style={{ alignItems: "flex-start" }}>
              {/* Eurocode generation is still a work in progress - dev environments only */}
              {isDev && (
                <Col className="ps-0 pe-4">
                  <div className="editfield-label">{t("eurocode_generation_.label")}</div>
                  <SXDropdown
                    name={"eurocode_generation_sel_.label"}
                    id="generationdropdown"
                    data-testid="dropdown_generation"
                    disabled={false}
                    list={EUROCODE_GENERATION}
                    val={generation ? GetGeneration(generation) : EUROCODE_GENERATION[0]}
                    onUpdate={async (val) => {
                      try {
                        if (val === null) {
                          return;
                        }
                        await update_generation(val);
                      } catch (x) {
                        report_exception(t, x);
                      }
                    }}
                    localisation={undefined}
                    lang={""}
                  ></SXDropdown>
                </Col>
              )}

              <Col className="ps-0 pe-4">
                <div className="editfield-label">{useMemo(() => t("national_annex_.label"), [t])}</div>
                <SXDropdown
                  name={"national_annex_sel_"}
                  id="annexdropdown"
                  data-testid="dropdown_annex"
                  disabled={false}
                  list={NATIONAL_ANNEXES}
                  val={annex ? GetCountry(annex) : { name: "not_set_.label", id: ng.eurocode.Annex.ANNEX_UNSPECIFIED }}
                  onUpdate={async (val) => {
                    try {
                      if (val === null) {
                        return;
                      }
                      await update_annex(val);
                    } catch (x) {
                      report_exception(t, x);
                    }
                  }}
                  localisation={undefined}
                  lang={""}
                ></SXDropdown>
              </Col>

              {/* Consequence class is EN 1990 Annex B, which is informative — whether CC1-CC3 drive
                  a KFI factor at all is a national choice, and of the annexes offered above only
                  Denmark's is built directly on it. Sweden and Finland differentiate through the
                  reliability class below instead (Finland's RC1-RC3 are the Annex B classes under
                  another name), and Great Britain's NA does not adopt KFI. Hidden rather than
                  disabled: a greyed-out class reads as "not decided yet" rather than "not part of
                  this annex". The stored value is left alone, so switching back to Denmark returns
                  the class the project already had. */}
              {annex === ng.eurocode.Annex.ANNEX_DENMARK && (
                <Col className="ps-0 pe-2">
                  <div className="editfield-label">{t("consequence_class_.label")}</div>
                  <SXDropdown
                    name={"cc"}
                    id={"ccdropdown"}
                    data-testid={"dropdown_consequence_class_"}
                    onUpdate={async (val) => {
                      try {
                        if (val === null) {
                          return;
                        }
                        await update_cc(val);
                      } catch (x) {
                        report_exception(t, x);
                      }
                    }}
                    list={CONSEQUENCE_CLASS}
                    val={cc ? { name: CONSEQUENCE_CLASS[cc - 1]?.name, id: CONSEQUENCE_CLASS[cc - 1]?.id } : null}
                    notSelectedName={t("not_set_.label")}
                    disabled={false}
                    localisation={undefined}
                    lang={""}
                  />
                </Col>
              )}

              {(annex === ng.eurocode.Annex.ANNEX_SWEDEN || annex === ng.eurocode.Annex.ANNEX_FINLAND) && (
                <Col className="ps-0 pe-2">
                  <div className="editfield-label">{t("reliability_class_.label")}</div>
                  <SXDropdown
                    name={"reliabilityClass"}
                    data-testid="dropdown_reliability_class"
                    onUpdate={async (val) => {
                      try {
                        if (val === null) {
                          return;
                        }
                        await update_reliabilityClass(val);
                      } catch (x) {
                        report_exception(t, x);
                      }
                    }}
                    list={RELIABILITY_CLASS}
                    val={
                      reliabilityClass
                        ? {
                            name: RELIABILITY_CLASS[reliabilityClass - 1]?.name,
                            id: RELIABILITY_CLASS[reliabilityClass - 1]?.id,
                          }
                        : null
                    }
                    notSelectedName={"not_set_.label"}
                    disabled={false}
                    localisation={undefined}
                    lang={""}
                  />
                </Col>
              )}
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};
